import { useState } from "react";
import { useParams } from "react-router-dom";
import { getStoredAccountType } from "../auth";
import { BeneficiariesPage } from "./BeneficiariesPage";
import { EnterpriseBeneficiariesPage } from "./EnterpriseBeneficiariesPage";
import { EnterpriseBeneficiaryDetailPage } from "./EnterpriseBeneficiaryDetailPage";

export function BeneficiariesPageRouter() {
  const [accountType] = useState(() => getStoredAccountType());
  const { type, id } = useParams();
  const beneficiaryId = id ? Number.parseInt(id, 10) : NaN;
  const beneficiaryType = type === "employee" || type === "dependant" ? type : null;

  if (
    accountType === "enterprise" &&
    beneficiaryType &&
    !Number.isNaN(beneficiaryId) &&
    beneficiaryId > 0
  ) {
    return (
      <EnterpriseBeneficiaryDetailPage type={beneficiaryType} beneficiaryId={beneficiaryId} />
    );
  }

  if (accountType === "enterprise") {
    return <EnterpriseBeneficiariesPage />;
  }

  return <BeneficiariesPage />;
}
